module.exports = __webpack_public_path__ + "img/nagamitsu.33ac487c.jpg";